import { render, staticRenderFns } from "./ServiceIntegration.vue?vue&type=template&id=ed9b5e9a&"
import script from "./ServiceIntegration.vue?vue&type=script&lang=js&"
export * from "./ServiceIntegration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports